<template>
  <div class="DBackaground">
  </div>
</template>

<script>
export default {
  name: "DBackaground"
}
</script>

<style lang="scss" scoped>
.DBackaground{
  width: 100%;
  height: 1147px;
  @include Position(1,5,0,0);
  @include BgImage(100%,1147px,'3d/header-bg.jpg',1);
  z-index: 2;
}
</style>
